<template>
  <div>
    <div v-if="drugs">
      <button type="button" class="btn btn-default" @click="shopCartModal = true">
        <span class="glyphicon glyphicon-shopping-cart"></span> Drug Allocation
        <span class="label label-success" v-if="hasAllocations()">
          <span class="glyphicon glyphicon-ok"></span>
        </span>
      </button>
    </div>

    <modal v-if="shopCartModal" @close="onCloseModal">
      <div slot="header">
        <h3>Allocate drugs for the current season (Apr-Aug) for {{ animalName }}</h3>

        <div class="row">
          <div class="col-md-4 col-md-offset-4">
            <input type="text" v-model="filter" class="form-control" placeholder="Search...">
          </div>
        </div>
      </div>

      <div slot="body">
        <div v-for="(drug, drugs_iteration_index) in filteredDrugs" :key="drug.pk">
          <div v-if="drug.inactive == false || drugsUsedLastYear[drug.pk] > 0">
            <div class="form-group row">
              <div class="col-md-4 col-md-offset-2">
                <h4  v-if="drugs_iteration_index == 0">
                  Quantity Purchased previous dry cow season (Apr-Aug)
                </h4>
                <label> {{ drug.name }} </label>
                <input type="number" :value="drugsUsedLastYear[drug.pk]" class="form-control" disabled>
              </div>

              <div class="col-md-4">
                <h4 v-if="drugs_iteration_index == 0">{{ animalName }}</h4>
                <label> {{ drug.name }} </label>
                <input type="number"
                       v-model="newAllocations[drug.pk]"
                       :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                       class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../../Modal'
import { mapActions } from 'vuex'

export default {
  props: [
    'animalName',
    'drugs',
    'allocations',
    'isReadOnly',
    'drugsUsedLastYear',
  ],
  components: {
    Modal
  },
  data() {
    return {
      shopCartModal: false,
      filter: '',
      newAllocations: {}
    }
  },
  created: function() {
    for (const drug of this.drugs) {
      this.newAllocations[drug.pk] = 0
    }

    for (const allocation of this.allocations) {
      this.newAllocations[allocation.drug_allocation_product] = allocation.par_qty
    }
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldValue']),
    onCloseModal: function() {
      this.shopCartModal = false
      let collectedAllocations = Object.assign([], this.allocations)

      Object.entries(this.newAllocations).forEach(([key, value]) => {
        let alloc = this.allocations.find(alloc => alloc.drug_allocation_product == key)

        if (!value) {
          value = 0
        }

        if (alloc) {
          alloc.par_qty = value
        } else if (value > 0) {
          collectedAllocations = collectedAllocations.filter(alloc => alloc.drug_allocation_product != key)
          collectedAllocations.push({drug_allocation_product: key, par_qty: value})
        }
      })

      this.$emit('new-allocations', {allocations: collectedAllocations})
    },
    hasAllocations: function() {
      return Object.values(this.newAllocations).some((par_qty) => par_qty > 0)
    }
  },
  computed: {
    searching: function () {
      return Boolean(this.filter);
    },
    activeDrugs: function ()
    {
      return this.drugs.filter(drug => drug.inactive == false)
    },
    filteredDrugs: function() {
      return (this.filter)
        ? this.activeDrugs.filter(drug => drug.name.toLowerCase().includes(this.filter.toLowerCase()))
        : this.activeDrugs
    },
  },
};
</script>
